/* Countdown timer — theme clone of "GSC Countdown Timer". Config: metaobject "Odbrojavanje". One shared 1 s tick for all timers. */
(function () {
  var DAY = { Sun: 'Ned', Mon: 'Pon', Tue: 'Uto', Wed: 'Sre', Thu: 'Čet', Fri: 'Pet', Sat: 'Sub' };
  var items = [], iv = null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function st(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function tzNow(tz) {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    } catch (e) { return null; }
    return o;
  }
  function hm(v, d) { var p = (v || d).split(':'); return (+p[0] * 60 + +p[1]) * 60; }
  function endOf(el) {
    var m = el.dataset.mode, now = Date.now();
    if (m === 'Dnevno') {
      var o = tzNow(el.dataset.tz); if (!o) return null;
      var days = (el.dataset.days || '').split(',').filter(Boolean);
      if (days.length && days.indexOf(DAY[o.weekday]) < 0) return null;
      var sec = (+o.hour % 24) * 3600 + +o.minute * 60 + +o.second, a = hm(el.dataset.from, '00:00'), b = hm(el.dataset.to, '23:59');
      if (b <= a) b += 86400;
      if (sec < a) sec += 86400;
      if (sec < a || sec >= b) return null;
      return now + (b - sec) * 1000;
    }
    if (m === 'Evergreen') {
      var k = 'cdt:' + el.dataset.h, dur = (+el.dataset.dur || 0) * 60000, s0 = +st(k) || 0;
      if (!s0) { s0 = now; st(k, s0); }
      if (s0 + dur <= now && el.dataset.onend === 'Ponovo pokreni' && dur > 0) { s0 = now; st(k, s0); }
      return s0 + dur;
    }
    return (+el.dataset.end || 0) * 1000;
  }
  function draw(el, ms) {
    var t = Math.max(0, Math.floor(ms / 1000)), d = Math.floor(t / 86400), h = Math.floor(t % 86400 / 3600), mi = Math.floor(t % 3600 / 60), s = t % 60;
    var L = (el.dataset.labels || 'dana|sati|min|sek').split('|'), parts = [];
    if (el.dataset.fmt === 'h:m:s') h += d * 24; else parts.push([d, L[0]]);
    parts.push([h, L[1]], [mi, L[2]], [s, L[3]]);
    el._t.innerHTML = parts.map(function (p) { return '<span class="cdt__u"><b>' + pad(p[0]) + '</b>' + (p[1] ? '<small>' + esc(p[1]) + '</small>' : '') + '</span>'; }).join('<span class="cdt__sep">:</span>');
  }
  function step(it) {
    var el = it.el;
    if (!el.isConnected) { it.dead = 1; return; }
    var left = it.end - Date.now();
    if (left <= 0) {
      if (el.dataset.mode === 'Evergreen' && el.dataset.onend === 'Ponovo pokreni') { it.end = endOf(el); if (it.end > Date.now()) return draw(el, it.end - Date.now()); }
      if (el.dataset.onend === 'Prikaži tekst') el._t.textContent = el.dataset.endtext || ''; else el.hidden = true;
      it.dead = 1; return;
    }
    draw(el, left);
  }
  function tick() {
    items.forEach(step);
    items = items.filter(function (i) { return !i.dead; });
    if (!items.length) { clearInterval(iv); iv = null; }
  }
  function setup(el) {
    if (el._cdt) return; el._cdt = 1;
    var h = el.dataset.h;
    try { if (sessionStorage.getItem('cdt-x:' + h)) return el.remove(); } catch (e) {}
    var now = Date.now() / 1000;
    if (el.dataset.start && now < +el.dataset.start) return;
    if (el.dataset.stop && now > +el.dataset.stop) return;
    el._t = el.querySelector('.cdt__timer');
    var end = endOf(el);
    if (!end) return;
    if (end <= Date.now() && el.dataset.onend !== 'Prikaži tekst') return;
    el.hidden = false;
    var x = el.querySelector('.cdt__x');
    if (x) x.addEventListener('click', function () { try { sessionStorage.setItem('cdt-x:' + h, 1); } catch (e) {} el.remove(); });
    var c = el.querySelector('.cdt__coupon');
    if (c) c.addEventListener('click', function () {
      var code = c.dataset.code, b = c.querySelector('b');
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () { b.textContent = '✓'; setTimeout(function () { b.textContent = code; }, 1500); }, function () {});
    });
    var it = { el: el, end: end };
    items.push(it); step(it);
    if (!iv) iv = setInterval(tick, 1000);
  }
  function init() { document.querySelectorAll('[data-cdt]').forEach(setup); }
  var pend = null;
  function start() {
    init();
    new MutationObserver(function () { if (!pend) pend = setTimeout(function () { pend = null; init(); }, 150); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
